import { useCallback, useEffect, useState } from 'react';

const KEY_PREFIX = 'aima.tablePageSize.';
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

function readStored(tableId: string, fallback: number): number {
  if (typeof localStorage === 'undefined') return fallback;
  const raw = localStorage.getItem(KEY_PREFIX + tableId);
  if (!raw) return fallback;
  const parsed = Number(raw);
  return PAGE_SIZE_OPTIONS.includes(parsed) ? parsed : fallback;
}

export function useTablePageSize(tableId: string, defaultSize = 20): [number, (n: number) => void] {
  const [size, setSize] = useState<number>(() => readStored(tableId, defaultSize));

  useEffect(() => {
    setSize(readStored(tableId, defaultSize));
  }, [tableId, defaultSize]);

  const update = useCallback(
    (n: number) => {
      setSize(n);
      if (typeof localStorage !== 'undefined') localStorage.setItem(KEY_PREFIX + tableId, String(n));
    },
    [tableId],
  );

  return [size, update];
}
